import { getAppsCoreApiAuthMeQueryOptions } from '@/lib/api/generated/endpoints'
import type { AuthStatus } from '../types'

/**
 * Domain-named wrapper around orval-generated query options for GET /auth/me.
 *
 * orval typed the response data as `void` (OpenAPI schema didn't carry the
 * response body shape). We cast here to the actual runtime shape from
 * apps/core/api.py AuthStatusResponse: { authenticated, user }.
 *
 * Consumers receive AuthStatus | null (null = not-yet-fetched / unauthenticated).
 *
 * TData generic is explicit so TypeScript correctly infers ensureQueryData/useQuery
 * return type as AuthStatus | null instead of the raw orval response shape.
 */
export const currentUserQuery = () =>
  getAppsCoreApiAuthMeQueryOptions<AuthStatus | null>({
    query: {
      staleTime: 5 * 60 * 1000,
      retry: false,
      select: (res) => {
        // customFetch returns raw JSON body; orval types it as void but the
        // actual runtime shape is AuthStatus from apps/core/api.py AuthStatusResponse.
        const body = res as unknown as AuthStatus
        return body ?? null
      },
    },
  })
